<template>
  <div class="">
    <!--  -->
    <CollectModel
      v-if="type == 1"
      ref="CollectModel"
      @handleStart="handleStart"
    ></CollectModel>
    <!--  -->
    <OfficialCollect v-if="type == 2" ref="OfficialCollect"></OfficialCollect>
  </div>
</template>

<script>
import { detection } from "@/mixin/detection.js";
import OfficialCollect from "@/components/OfficialCollect.vue";
import CollectModel from "@/components/CollectModel.vue";
export default {
  mixins: [detection],
  name: "IntendCollect",
  components: {
    CollectModel,
    OfficialCollect,
  },
  data() {
    return {
      type:1,
    };
  },
  mounted() {
    
  },  
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>